import axios from "../axiosClient";

export const getSensors = async (
  PageNumber: any,
  pageSize: any,
  tcCode: any,
  siteCode: any,
  blockCode: any,
  testTypeId: any,
  SortBy: any,
  SortDirection: any,
  signal: any
) => {
  const res = await axios.get(
    `/slpapp/TestConfiguration/getSensorsByLocation`,
    {
      params: {
        PageNumber,
        pageSize,
        tcCode,
        siteCode,
        blockCode,
        testTypeId,
        SortBy,
        SortDirection,
      },
      signal,
    }
  );

  return res?.data;
};
